import React, {useEffect, useState} from 'react';
import "./AllEventsMonths.scss";
import AllEventsApi from "../../../../api/AllEventsApi";
import * as actionCreators from "../../../../store/actions/actions";
import {connect} from "react-redux";
import MonthItem from "../../EventsByMonth/MonthItem/MonthItem";
import {getLabelFromYearAndMonth, getMonthName} from "../../../../tools/formatter";
import UrlManager from "../../../../tools/UrlManager";
import Loading from "../../../../components/Loading/Loading";
import {Grid2} from "@mui/material";

function AllEventsMonths(props) {
    const [months, setMonths] = useState([]);
    const [labels, setLabels] = useState(null);

    const setCurrentNavigationMonth = (navigationMonth) => {
        props.onUpdateCurrentNavigationMonth(navigationMonth);
    }


    useEffect(() => {
        if ( props.userId && props.currentNavigationYear ) {
            setMonths([]);
            AllEventsApi.getByMonths(props.userId, props.currentNavigationYear).then(response => {
                let allMonths = new Array(13).fill({
                    "eventsCount": "0",
                    "imagesCount": "0",
                    "videosCount": "0"
                });
                response.rows.forEach(month => {
                    allMonths[month.eventsMonth] = month;
                });
                setMonths(allMonths);
            } ).catch(error => {
                //TODO catch
            });
            AllEventsApi.getLabels(props.userId, 'm', props.currentNavigationYear).then(response => {
                const labelsObject = Object.fromEntries(
                    response.map(item => [item.userdate, { userimage: item.userimage, transform: item.transform ?? null }])
                );
                setLabels(labelsObject);
            } ).catch(error => {
                //TODO catch
            });
        }
    }, [props.userId, props.currentNavigationYear]);


    return props.userId && props.currentNavigationYear ? <div className="AllEventsMonths">
        <Grid2 container spacing={2}>{months.length > 0 ? months.map((monthInfo, index) => {
        return (
            index > 0 ?
                <Grid2 key={index} size={{ xs: 12, sm: 4, lg: 2 }} sx={{ border: index === parseInt(props.currentNavigationMonth) ? '2px solid #1976d2' : '' }} onClick = {() => {
                    setCurrentNavigationMonth(index);
                    UrlManager.setUrl(props.userId, props.currentNavigationYear, index);
                }}>
                    <MonthItem label={labels ? (labels[getLabelFromYearAndMonth(props.currentNavigationYear, index)] ?? false) : null} item={monthInfo}  monthNumber={index} />
                </Grid2> : ''
        )
    }) : <Loading />}</Grid2>
    </div> : '';
}

const mapStateToProps = state => {
    return {
        currentNavigationYear: state.eventsData.currentNavigationYear,
        currentNavigationMonth: state.eventsData.currentNavigationMonth
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCurrentNavigationMonth: (currentNavigationMonth) => dispatch(actionCreators.updateNavigationMonth(currentNavigationMonth))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEventsMonths);
